import AllViewsButton from './AllViewsButton';

/**
 * This is an encapsulation of our own "All views" link implementation.
 * Since PinnedViewsBar requires a component with a pre-defined set of properties, we can't directly render our "AllViewsButton" link component
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibAllViewsLink() {
  return /*#__PURE__*/_jsx(AllViewsButton, {});
}